import { trackingApi } from '@/api/tracking'
import { getStorage, setStorage } from '@/utils/storage'
import { STORAGE_KEYS } from '@/constants/storageKeys'
import logger from '@/utils/logger'

/**
 * 收集并上报追踪数据
 */
export async function collectTrackingData() {
  try {
    // 1. 获取 URL 参数
    const params = new URLSearchParams(window.location.search)
    const urlParams = {}
    for (const [key, value] of params.entries()) {
      urlParams[key] = value
    }
    const hasQueryParams = Object.keys(urlParams).length > 0
    // 保存完整来源 URL，后端可直接从 sourceurl 解析邀请码 code
    urlParams.sourceurl = window.location.href

    // 2. 检查是否有需要上报的数据 (如果有 URL 参数或者还没有 client_id)
    const hasParams = hasQueryParams
    const hasClientId = !!getStorage(STORAGE_KEYS.CLIENT_ID)
    
    // 如果既没有参数，又已经有了 client_id，则跳过上报，节省资源
    // 除非我们想每次会话都刷新一下 IP/User-Agent
    if (!hasParams && hasClientId) {
      return
    }

    // 3. 构造请求体
    const payload = {
      url_params: hasParams ? urlParams : undefined,
      client_id: getStorage(STORAGE_KEYS.CLIENT_ID) // 如果有旧的 ID 也带上
    }

    // 4. 调用 API
    const res = await trackingApi.collect(payload)
    
    // 5. 保存返回的 client_id
    // 后端返回格式: { status: "0", data: { client_id: "..." } }
    const returnedClientId = res?.data?.data?.client_id || res?.data?.client_id
    if (returnedClientId) {
      setStorage(STORAGE_KEYS.CLIENT_ID, returnedClientId)
    }
  } catch (error) {
    logger.warn('[Tracking] Collect failed:', error)
  }
}
